import React, { useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong, faBolt, faBell, faUserShield, faCloudArrowUp, faLightbulb } from '@fortawesome/free-solid-svg-icons';

import logo from '../../assets/images/logo.png';
import '../../styles/Login.css';

const SWIFTBOARD_URL = process.env.REACT_APP_FRONTEND_SWIFTBOARD_URL?.replace(/\/$/, '');

const FEATURES = [
    { icon: faBolt,         color: 'amber',  text: 'Real-time project status updates' },
    { icon: faBell,         color: 'blue',   text: 'Instant bid submission notifications' },
    { icon: faUserShield,   color: 'green',  text: 'Secure dedicated client profile' },
    { icon: faCloudArrowUp, color: 'purple', text: 'Easy plan upload & tracking' },
    { icon: faLightbulb,    color: 'red',    text: 'Smarter decisions with live data' },
];

const Login = () => {
    const [redirecting, setRedirecting] = useState(null);

    const handleRedirect = (path) => {
        setRedirecting(path);
        setTimeout(() => {
            window.location.href = `${SWIFTBOARD_URL}/${path}`;
        }, 300);
    };

    return (
        <section className="login-section">
            <div className="login-bg-overlay" />

            <div className="login-container">

                {/* ── Left panel ── */}
                <div className="login-panel login-panel-left">

                    <div className="login-brand">
                        <img width="527" height="504" decoding="async" src={logo} alt="Surya Group" className="login-brand-logo" />
                        <span>Surya Group</span>
                    </div>

                    <div className="login-badge">SwiftBoard Portal</div>

                    <h1 className="login-headline">
                        Track Your Projects<br />
                        <span>with Confidence</span>
                    </h1>

                    <p className="login-sub">
                        Gain full control of your projects with Surya Group's secure
                        client portal. Stay informed and make smarter decisions with ease.
                    </p>

                    <ul className="login-features">
                        {FEATURES.map(({ icon, color, text }) => (
                            <li key={text}>
                                <span className={`login-feat-icon login-feat-icon--${color}`}>
                                    <FontAwesomeIcon icon={icon} />
                                </span>
                                {text}
                            </li>
                        ))}
                    </ul>

                    <div className="login-actions">
                        <button
                            className="login-btn login-btn-primary"
                            onClick={() => handleRedirect('login')}
                            disabled={redirecting !== null}
                        >
                            {redirecting === 'login' ? (
                                <><span className="btn-spinner" /> Redirecting…</>
                            ) : 'Login to Portal'}
                        </button>

                        <button
                            className="login-btn login-btn-secondary"
                            onClick={() => handleRedirect('register')}
                            disabled={redirecting !== null}
                        >
                            {redirecting === 'register' ? (
                                <><span className="btn-spinner" /> Redirecting…</>
                            ) : (
                                <>Create Account <FontAwesomeIcon icon={faArrowRightLong} /></>
                            )}
                        </button>
                    </div>

                </div>

                {/* ── Right panel ── */}
                <div className="login-panel login-panel-right">
                    <div className="login-video-wrap">
                        <div className="login-video-label">See how it works</div>
                        <div className="login-video-player">
                            <ReactPlayer
                                url="https://youtu.be/09uTuNdTcg0?si=KE9bQJzanfHU8pjV"
                                width="100%"
                                height="100%"
                                controls
                            />
                        </div>
                        <p className="login-video-caption">
                            Surya Group SwiftBoard — project management made simple
                        </p>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default Login;
